import React from 'react';
import { Calendar, Card, List, Button, Typography, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const BookingSection = ({
  service,
  selectedDate,
  loadingTimeSlots,
  availableTimeSlots,
  onSelectDate,
  dateCellRender,
  onBookNow,
  isCheckoutLoading
}) => {
  return (
    <div className="card">
      <div className="header" style={{ paddingBottom: '0px', marginBottom: '0px' }}>
        <h2><strong>Bookings</strong></h2>
      </div>
      <div className="body">
        {/* Booking UI with Calendar */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {/* Calendar Component */}
          <Calendar
            fullscreen={false}
            onSelect={onSelectDate}
            dateCellRender={dateCellRender}
          />
          {/* Display Selected Date */}
          {selectedDate && (
            <Card title={`Available Time Slots for ${selectedDate}`}>
              {loadingTimeSlots ? (
                <div style={{ textAlign: 'center', padding: '24px' }}>
                  <Spin tip="Loading time slots..." />
                </div>
              ) : availableTimeSlots.length > 0 ? (
                <List
                  itemLayout="horizontal"
                  dataSource={availableTimeSlots}
                  renderItem={(slot) => {
                    const spotsLeft = slot.availability - (slot.purchases || 0);
                    return (
                      <List.Item
                        actions={[
                          <Button
                            type="primary"
                            size="large"
                            disabled={spotsLeft <= 0 || isCheckoutLoading}
                            onClick={() => onBookNow(slot)}
                            loading={isCheckoutLoading}
                          >
                            {spotsLeft > 0 ? 'Book' : 'Sold Out'}
                          </Button>,
                        ]}
                      >
                        <List.Item.Meta
                          title={`${slot.startTime} - ${slot.endTime}`}
                          description={
                            <>
                              <Text type={spotsLeft > 0 ? 'success' : 'danger'}>
                                {spotsLeft > 0 ? `${spotsLeft} spots left` : 'No spots left'}
                              </Text>
                              <br />
                              <Text>Price: ${service.price}</Text>
                            </>
                          }
                        />
                      </List.Item>
                    );
                  }}
                />
              ) : (
                <Text>No available time slots for this date.</Text>
              )}
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingSection; 